import usePrefetchBatchTracking from '../../hooks/usePrefetchBatchTracking';
import type { Kitchen } from '../../libs';

type BatchTrackingPrefetchProps = { kitchen: Kitchen; date: string; canViewBatchTracking: boolean };

// A component, so the minute clock behind the prefetch re-renders this and not App.
const BatchTrackingPrefetch = (props: BatchTrackingPrefetchProps) => {
  usePrefetchBatchTracking(props);
  return null;
};

export default BatchTrackingPrefetch;
